module.exports = __webpack_public_path__ + "media/images/product/f_a-b2c578c5364c53d3a6545b0a35a97edf.png";